import React, { useMemo } from 'react';

import FeatureGates from '@atlaskit/feature-gate-js-client/feature-gates';

import { useEditionAwareness } from '../../../services/edition-awareness-context';
import { getJiraApplicationKey } from '../../../services/get-jira-application-key';
import { getJiraProjectTypeKey } from '../../../services/get-jira-project-type-key';
import { ModalEntryPoint } from '../shared/modal-entry-point';
import { DIALOG_CONFIG } from './dialog-config';
import { entryPoint, type EntryPointParams } from './freeToStandardModal.entrypoint';

export function FreeToStandardModal(): React.JSX.Element {
	const { product, cloudId } = useEditionAwareness();
	const isStorageLimitsExperimentEnabled: boolean =
		(product === 'jira-service-management' || product === 'jira-customer-service') &&
		FeatureGates.getExperimentValue<boolean>(
			'jsmgrowth-267_enforce_storage_limits_servco_free',
			'isEnabled',
			false,
		);

	const jiraApplicationKey = getJiraApplicationKey(product);
	const projectType = getJiraProjectTypeKey(product);

	const isJira = isStorageLimitsExperimentEnabled
		? product === 'jira' || product === 'jira-product-discovery'
		: product === 'jira' ||
			product === 'jira-product-discovery' ||
			product === 'jira-service-management';

	const entryPointParams: EntryPointParams = useMemo(
		() => ({
			cloudId,
			// Fallback to any valid value since this means that we're not using jira
			jiraApplicationKey: jiraApplicationKey ?? 'JIRA_SOFTWARE',
			// Fallback to any valid value since this means that we're not using jira
			projectType: projectType ?? 'SOFTWARE',
			isJira,
			isConfluence: product === 'confluence',
			isServiceCollectionFree:
				product === 'jira-service-management' && isStorageLimitsExperimentEnabled,
		}),
		[cloudId, product, projectType, jiraApplicationKey, isJira, isStorageLimitsExperimentEnabled],
	);

	const modalProps = useMemo(() => ({ width: 'x-large' }), []);

	return (
		<ModalEntryPoint
			entryPoint={entryPoint}
			entryPointParams={entryPointParams}
			modalProps={modalProps}
			dialogConfig={DIALOG_CONFIG}
		/>
	);
}
